import type { Address } from '~/api/graphql/generated/types'

// This file is temporary until we have the new public API, doing this to unblock FE work
export enum ClinicStatus {
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
  CLOSED = 'CLOSED',
}

export interface Clinic {
  address: Address
  fax: string
  hin: string
  id: string
  name: string
  phone: string
  status: ClinicStatus
  websiteUrl: string
}
export interface PreviousMedicalRecordConsent {
  /**
   * Consent to collect previous medical records from the clinics listed.
   * True  -> Consent was granted
   * False -> Consent was denied
   * null  -> Consent was skipped (e.g. no previous clinics)
   * Note: In all cases, consent was requested.
   */
  consent: boolean | null
  /**
   * Note: All clinic contacts should contain a Kyrios ID.
   */
  previousClinicContacts: Clinic[] // TODO: Refactor to Contact[] type if needed, once clarification is received from engineering
}
